<div class="breadcrumb-area">
	<h1>Reportes de Bancos</h1>
</div>

<div class="card mb-3" id="monetaryOrSavingReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==1?0:1">
		<h3>Control de cuentas monetarias y de ahorros</h3>
		<h3><i [ngClass]="selectedReport==1?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==1">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate1" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate1" name="endDate1" class="form-control">
				</div>
			</div>
		</div>
		<div class="card custom-card" *ngFor="let report of reportsMonetaryOrSaving; let i = index">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h3>{{report.name}}</h3>
				<div class="col-sm-2 download-buttons">
					<button [disabled]="report.excel" (click)="getMonetaryOrSavingReport('excel',report)"
						class="btn btn-success" data-bs-toggle="tooltip" title="Descargar Excel"><i
							*ngIf="!report.excel" class="fa fa-file-excel"></i>
						<span *ngIf="report.excel" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button [disabled]="report.pdf" (click)="getMonetaryOrSavingReport('pdf', report)"
						class="btn btn-primary" data-bs-toggle="tooltip" title="Descargar PDF"><i *ngIf="!report.pdf"
							class="fa fa-file-pdf"></i>
						<span *ngIf="report.pdf" class="spinner-border spinner-border-sm"
							aria-hidden="true"></span></button>
					<button class="btn btn-secondary" data-bs-toggle="tooltip" title="Ver Reporte"><i
							class="fa fa-eye"></i></button>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="movementsReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="showMovesReport()">
		<h3>Movimiento de cuentas y reportería</h3>
		<h3><i [ngClass]="selectedReport==2?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==2">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="startDate2" class="form-label">Fecha Inicial:</label>
					<input type="date" [(ngModel)]="startDate" id="startDate2" name="startDate2" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="endDate2" class="form-label">Fecha Final:</label>
					<input type="date" [(ngModel)]="endDate" id="endDate2" name="endDate2" class="form-control">
				</div>
			</div>
		</div>
		<div class="card custom-card">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h3>Cuentas monetarias</h3>
			</div>
			<div class="card-body">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Número de cuenta</th>
								<th>Nombre</th>
								<th class="text-end">Monto</th>
								<th class="td-center">Movimientos</th>
								<th class="td-center">Excel</th>
								<th class="td-center">PDF</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let account of paginationAccounts.filter">
								<td>{{account.accountNumber}}</td>
								<td>{{account.alias}}</td>
								<td class="text-end">{{account.balance | currency: (account.currency == 0 ? 'Q':'$')}}
								</td>
								<td class="td-center">
									<i (click)="showModalMovements(account)" class="clickeable fa fa-eye"></i>
								</td>
								<td class="td-center">
									<i (click)="getMovesReport('excel',account)" *ngIf="!account.excel"
										class="clickeable fa fa-download"></i>
									<span *ngIf="account.excel" class="spinner-border spinner-border-sm"
										aria-hidden="true"></span>
								</td>
								<td class="td-center">
									<i (click)="getMovesReport('pdf',account)" *ngIf="!account.pdf"
										class="clickeable fa fa-download"></i>
									<span *ngIf="account.pdf" class="spinner-border spinner-border-sm"
										aria-hidden="true"></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAccounts.total.length > 0"
					[elements]="paginationAccounts"></app-pagination-custom>
			</div>
		</div>
		<div class="card custom-card">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h3>Cuentas de ahorro</h3>
			</div>
			<div class="card-body">
				<ng-container *ngIf="paginationAccountsSaving.total.length>0">
					<div class="table-responsive">
						<table style="margin-bottom: 0px !important;" class="table table-striped">
							<thead>
								<tr>
									<th>Número de cuenta</th>
									<th>Nombre</th>
									<th class="td-center">Monto</th>
									<th class="td-center">Movimientos</th>
									<th class="td-center">Excel</th>
									<th class="td-center">PDF</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let account of paginationAccountsSaving.filter">
									<td>{{account.accountNumber}}</td>
									<td>{{account.alias}}</td>
									<td class="td-center">{{account.balance}}</td>
									<td class="td-center"><i class="i-hover fa fa-eye"></i></td>
									<td class="td-center"><i class="i-hover fa fa-download"></i></td>
									<td class="td-center"><i class="i-hover fa fa-download"></i></td>
								</tr>
							</tbody>
						</table>
					</div>
					<app-pagination-custom *ngIf="paginationAccountsSaving.total"
						[elements]="paginationAccountsSaving"></app-pagination-custom>
				</ng-container>
				<ng-container *ngIf="paginationAccountsSaving.total.length == 0">
					<span class="text-muted"><i class="fa fa-circle-info"></i>No se cuentan con cuentas de ahorro</span>
				</ng-container>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="cashMovements">
	<div class="title-report card-header d-flex justify-content-between align-items-center" (click)="getCashiers()">
		<h3>Movimiento de cajas</h3>
		<h3><i [ngClass]="selectedReport==4?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==4">
		<div class="card custom-card">
			<div class="card-header d-flex justify-content-between align-items-center">
				<h3>Cajas</h3>
			</div>
			<div class="card-body">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th rowspan="2">Nombre</th>
								<th rowspan="2">Bodega</th>
								<th colspan="2" class="text-center">Montos</th>
								<th rowspan="2" class="td-center">Movimientos</th>
							</tr>
							<tr>
								<th class="text-end">Local</th>
								<th class="text-end">Foraneo</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let cashier of paginationCashiers.filter">
								<td>{{cashier.name}}</td>
								<td>{{warehouseNames[cashier.warehouse]}}
									<div *ngIf="!cashier.warehouse"
										style="display: flex; justify-content: start;">
										<div class="superposition-parent" style="width: 1rem;" tooltip="No pertenece a una bodega">
											<i class="fa fa-warehouse"></i>
											<i class="fa fa-question superposition-icon"></i>
										</div>
									</div>
								</td>
								<td class="text-end">{{cashier.amount | currency: 'Q'}}
								</td>
								<td class="text-end">{{cashier.amountForeign | currency: '$'}}
								</td>
								<td class="td-center">
									<i (click)="showModalCash(cashier)" class="clickeable fa fa-eye"></i>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationCashiers.total.length > 0"
					[elements]="paginationCashiers"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>

<div class="card mb-3" id="advanceReport">
	<div class="title-report card-header d-flex justify-content-between align-items-center"
		(click)="selectedReport = selectedReport==3?0:3">
		<h3>Anticipos y reportería</h3>
		<h3><i [ngClass]="selectedReport==3?'fa-minus':'fa-plus'" class="fa"></i></h3>
	</div>
	<div class="card-body" *ngIf="selectedReport==3">
		<div class="row">
			<div class="col-sm">
				<div class="form-group">
					<label for="date4" class="form-label">Fecha:</label>
					<input type="date" [(ngModel)]="endDate" id="date4" name="date4" class="form-control">
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="type4" class="form-label">Transferencia: </label>
					<select name="type4" [(ngModel)]="transfer" id="type4" class="form-select">
						<option label="Todas" value="all" selected="selected">Todas</option>
						<option label="Entradas" value="in">Entradas</option>
						<option label="Salidas" value="out">Salidas</option>
					</select>
				</div>
			</div>
			<div class="col-sm">
				<div class="form-group">
					<label for="filterAdvanceReport" class="form-label">Búsqueda</label>
					<input type="text" id="filterAdvanceReport" placeholder="Nombre, cuenta o monto"
						name="filterAdvanceReport" class="form-control">
				</div>
			</div>
			<div class="col-sm download-buttons">
				<button class="btn btn-success" (click)="getAdvanceReport('excel')" data-bs-toggle="tooltip"
					title="Descargar Excel"><i class="fa fa-file-excel"></i></button>
				<button class="btn btn-primary" (click)="getAdvanceReport('pdf')" data-bs-toggle="tooltip"
					title="Descargar PDF"><i class="fa fa-file-pdf"></i></button>
				<button class="btn btn-secondary" (click)="getAdvanceReportJson()" data-bs-toggle="tooltip"
					title="Ver Reporte"><i class="fa fa-eye"></i></button>
			</div>
			<ng-container *ngIf="paginationAdvance.total.length > 0">
				<div class="table-responsive">
					<table style="margin-bottom: 0px !important;" class="table table-striped">
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Número de documento</th>
								<th>Beneficiario</th>
								<th>Saldo</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let advance of paginationAdvance.filter">
								<td>{{getDateFormattedString(advance.date)}}</td>
								<td>{{advance.docNumber}}</td>
								<td>{{advance.beneficiary?advance.beneficiary:''}}</td>
								<td>{{advance.amount}}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom *ngIf="paginationAdvance.total.length > 0 "
					[elements]="paginationAdvance"></app-pagination-custom>
			</ng-container>
		</div>
	</div>
</div>

<app-simple-modal *ngIf="accountModal" [title]="'Movimientos de Cuenta - '+ accountModal.accountNumber" (close)="accountModal = null;"
	[requiredFields]="false" [max]="80">
	<div fields>
		<div class="row">
			<div class="col form-goup">
				<label for="search" class="form-label">Buscar</label>
				<input type="text" name="search" id="search" class="form-control"
					placeholder="Beneficiario, Cuenta o Monto" [(ngModel)]="search.word" (input)="filterReport()">
			</div>
			<div class="col form-goup">
				<label for="startDateMovement" class="form-label">Fecha Inicial</label>
				<input type="date" name="startDateMovement" id="startDateMovement" (change)="getMovesReportInModal()"
					class="form-control" [(ngModel)]="search.startDate">
			</div>
			<div class="col form-goup">
				<label for="endDateMovement" class="form-label">Fecha Final</label>
				<input type="date" name="endDateMovement" id="endDateMovement" (change)="getMovesReportInModal()"
					class="form-control" [(ngModel)]="search.endDate">
			</div>
		</div>
		<p class="text-center mt-3">
			<i class="fa fa-bank" tooltip="Banco" *ngIf="accountModal.bankName"></i>{{accountModal.bankName}}
			<i style="margin-left: 1rem;" class="fa fa-key" tooltip="Número de cuenta"></i>{{accountModal.accountNumber}}
		</p>
		<ng-container *ngIf="accountModal.allMoves?.length > 0">
			<div class="table-responsive" style="margin: 0;">
				<table class="table" style="margin: 0;">
					<thead>
						<tr>
							<th>Fecha</th>
							<th>No. Documento</th>
							<th>Beneficiario</th>
							<th class="text-end">Ingreso</th>
							<th class="text-end">Egreso</th>
							<th class="text-end">Saldo</th>
							<th>Descripción</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let move of paginationMoves.filter">
							<td>{{move.date | date: 'dd/MM/YYYY'}}</td>
							<td>{{move.docNumber}}</td>
							<td>
								{{move.beneficiary}}
								<div *ngIf="!move.beneficiary"
									style="display: flex; justify-content: start;">
									<div class="superposition-parent" tooltip="No hay beneficiario" style="width: 1rem;">
										<i class="fa fa-person"></i>
										<i class="fa fa-question superposition-icon"></i>
									</div>
								</div>
							</td>
							<td class="text-end">{{move.incoming | currency: (accountModal.currency == 0? 'Q':'$')}}
							</td>
							<td class="text-end">{{move.outcoming | currency: (accountModal.currency == 0? 'Q':'$')}}
							</td>
							<td class="text-end">{{move.balance | currency: (accountModal.currency == 0? 'Q':'$')}}</td>
							<td>{{move.description}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-pagination-custom [elements]="paginationMoves"></app-pagination-custom>
		</ng-container>
		<ng-container *ngIf="!accountModal.allMoves || accountModal.allMoves.length == 0">
			<p class="display-3 text-info mt-3 text-center">
				<i class="fa fa-circle-info"></i> No existen movimientos en las fechas indicadas
			</p>
		</ng-container>
	</div>
</app-simple-modal>

<app-simple-modal *ngIf="cashModal" [title]="'Movimientos de Caja - '+ cashModal.name" (close)="cashModal = null;"
	[requiredFields]="false" [max]="80">
	<div fields>
		<div class="row">
			<div class="col form-goup">
				<label for="searchCash" class="form-label">Buscar</label>
				<input type="text" name="searchCash" id="searchCash" class="form-control"
					placeholder="Empleado, Documento o Monto" [(ngModel)]="searchCash.word" (input)="filterReportCash()">
			</div>
			<div class="col form-goup">
				<label for="startDateMovementCash" class="form-label">Fecha Inicial</label>
				<input type="date" name="startDateMovementCash" id="startDateMovementCash" (change)="getMovesCashInModal()"
					class="form-control" [(ngModel)]="searchCash.startDate">
			</div>
			<div class="col form-goup">
				<label for="endDateMovementCash" class="form-label">Fecha Final</label>
				<input type="date" name="endDateMovementCash" id="endDateMovementCash" (change)="getMovesCashInModal()"
					class="form-control" [(ngModel)]="searchCash.endDate">
			</div>
		</div>
		<ng-container *ngIf="cashModal.allMoves?.length > 0">
			<div class="table-responsive" style="margin: 0;">
				<table class="table" style="margin: 0;">
					<thead>
						<tr>
							<th rowspan="2">Fecha</th>
							<th colspan="2">Empleado</th>
							<th rowspan="2">Documento</th>
							<th class="text-end" rowspan="2">Monto</th>
							<th rowspan="2">Descripción</th>
						</tr>
						<tr>
							<th>Código</th>
							<th>Email</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let move of paginationMovesCash.filter">
							<td>{{move.mdate | date: 'dd/MM/YYYY'}}</td>
							<td>{{move.employeeAlpha}}</td>
							<td>{{move.employeeEmail}}</td>
							<td>{{move.document}}</td>
							<td class="text-end">{{move.moveAmount | currency: (move.currencyDescription == 'Quetzales' ? 'Q':'$')}}
								<i [tooltip]="move.transactionType" [ngClass]="move.transactionType=='INGRESO'?'fa-circle-up':'fa-circle-down'" class="fa"></i>
							</td>
							<td>{{move.docTypeDescription}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<app-pagination-custom [elements]="paginationMovesCash"></app-pagination-custom>
		</ng-container>
		<ng-container *ngIf="!cashModal.allMoves || cashModal.allMoves.length == 0">
			<p class="display-3 text-info mt-3 text-center">
				<i class="fa fa-circle-info"></i> No existen movimientos en las fechas indicadas
			</p>
		</ng-container>
	</div>
</app-simple-modal>